import { render } from "./UserActive.vue?vue&type=template&id=6ee2305c"
import script from "./UserActive.vue?vue&type=script&setup=true&lang=js"
export * from "./UserActive.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/User/UserActive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ee2305c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ee2305c', __exports__)) {
    api.reload('6ee2305c', __exports__)
  }
  
  module.hot.accept("./UserActive.vue?vue&type=template&id=6ee2305c", () => {
    api.rerender('6ee2305c', render)
  })

}


export default __exports__